export default {
	"beyond-books": {
		titleKey: {
			zh: "不止于纸上的故事",
			en: "Beyond Books"
		},
		descriptionKey: {
			zh: "以小说为主的原创系列，各篇章构成同一世界观。另有网页互动版与预告片等衍生，跑团是其中一种呈现形式。",
			en: "An original series centered on novels, with each chapter sharing one worldview. Also includes a web interactive edition and trailers — tabletop RPG is one way the stories are presented."
		},
		slugs: [
			"playground-tower-space-elevator",
			"beyond-books-silver-moon",
			"beyond-books-dragon-dance",
			"beyond-books-rule",
			"beyond-books-disillusionment",
			"beyond-books-ice-age",
			"beyond-books-childhood-trailer",
			"beyond-books"
		]
	},
	"heart-world": {
		titleKey: {
			zh: "心界",
			en: "Heart World"
		},
		descriptionKey: {
			zh: "心界游戏与同系列动画，同一原创宇宙的不同媒介。",
			en: "The Heart World game and animations in the same series — one original universe across media."
		},
		slugs: [
			"heart-world",
			"heart-world-jin-captain",
			"heart-world-wave-breaker"
		]
	},
	"gaokao": {
		titleKey: {
			zh: "高考纪事",
			en: "Gaokao Chronicles"
		},
		descriptionKey: {
			zh: "关于高考逆袭、志愿填报与考后心境的视频记录。",
			en: "Videos on Gaokao comeback, college application, and life after the exam."
		},
		slugs: [
			"gaokao-comeback-story",
			"exam-cheer-2026",
			"gaokao-application-guide",
			"gaokao-aftermath"
		]
	},
	"starfall": {
		titleKey: {
			zh: "星辉落",
			en: "Starfall"
		},
		descriptionKey: {
			zh: "以萝北真实经历改编。视觉小说 Demo 为序章，后转入小说《背叛书》。",
			en: "Adapted from Luobei's real experience. The VN demo is the prologue; development continued as the Book of Betrayal novel series."
		},
		slugs: [
			"xinghuiluo",
			"book-of-betrayal"
		]
	}
};
